import { Text } from "@overmap-ai/blocks"
import { type Asset, computeModelIndex } from "@overmap-ai/common"
import { selectAssetById, selectAssetTypeById } from "@overmap-ai/core"
import { cx } from "class-variance-authority"
import { memo } from "react"

import { useAppSelector } from "../../store"
import type { BaseIndexLabelProps } from "./typings"

interface AssetIndexLabelProps extends BaseIndexLabelProps {
	assetId: Asset["uuid"]
}

export const AssetIndexLabel = memo((props: AssetIndexLabelProps) => {
	const { className, assetId, ...rest } = props

	const asset = useAppSelector(selectAssetById(assetId))

	if (!asset) {
		throw new Error(`Could not find asset ${assetId} in store.`)
	}

	const assetType = useAppSelector(selectAssetTypeById(asset.asset_type ?? ""))!

	return (
		<Text className={cx("shrink-0 text-nowrap", className)} {...rest}>
			{computeModelIndex(assetType, asset)}
		</Text>
	)
})
AssetIndexLabel.displayName = "AssetIndexLabel"
